import './App.css';
import * as tf from '@tensorflow/tfjs';
import React, { useState, useEffect } from 'react';
import { MathJaxContext } from 'better-react-mathjax';
import { Slider, Box, Typography } from '@mui/material';

import itertools from './itertools';
import TensorWidget from './TensorWidget';
import DemoModal from './DemoModal';


function App() {
  // createRoot(document.getElementById('root')).render(
  const [N, setN] = useState(4);
  const [cube, setCube] = useState(tf.mul(tf.tensor2d(itertools.subsets(N)), .22));
  const [showHyperplanes, setShowHyperplanes] = useState(true);
  const [showPolytope, setShowPolytope] = useState(true);
  const [showSignVectors, setShowSignVectors] = useState(true);

  useEffect(() => {
    let cb = tf.mul(tf.tensor2d(itertools.subsets(N)), .22);
    setCube(cb);
  }, [N]);

  // function onChange(e) {
  //   setN(e);
  //   // let cb = tf.tensor2d(itertools.subsets(N));
  //   // cb = tf.mul(cb, .25);
  //   // setCube(cb);
  // }

  let marks = [];
  for (let i=2; i<=5; i++) {
      marks.push({value: i, label: i});
  }

  return (
    <MathJaxContext>
      <div className='container'>
        <DemoModal N={N} />
        <Box maxWidth="md" className="controls-bottom">
            <Typography id="input-slider" className="labels" gutterBottom>
                Number of Hyperplanes
            </Typography>
            <Slider
             aria-label="Number of Hyperplanes"
             defaultValue={4}
             getAriaValueText={setN}
             valueLabelDisplay="auto"
             step={1}
             marks={marks}
             min={2}
             max={5}
            />
        </Box>
        <TensorWidget N={N} polytope={cube} />
      </div>
    </MathJaxContext>
    );
}

export default App;
